// Shared sub-categorization for the Reports panel + the Process Forms source
// picker. Backend's `classify_uploaded_file` (api/ai_assistant.py:654) returns
// one of: 'Labs' | 'Images' | 'Medical Records' | 'Other'. We use those raw
// keys as the canonical classification values throughout and only translate
// to a human label at the render site.

export const REPORT_CLASSIFICATIONS = ['Labs', 'Images', 'Medical Records', 'Other'];

export const REPORT_LABELS = {
  Labs: 'Labs',
  Images: 'Imaging',
  'Medical Records': 'Medical Records',
  Other: 'Other Documents',
};

export function reportClassificationOf(item) {
  const c = (item && item.classification) || 'Other';
  return REPORT_LABELS[c] ? c : 'Other';
}

// Group an array of items that each carry a `classification` field into
// {classification, label, items}[] ordered by REPORT_CLASSIFICATIONS.
// Empty buckets are dropped so the UI doesn't render headers with no rows.
export function groupReportsByClassification(items) {
  const buckets = new Map(REPORT_CLASSIFICATIONS.map((k) => [k, []]));
  for (const it of items || []) {
    const k = reportClassificationOf(it);
    if (!buckets.has(k)) buckets.set(k, []);
    buckets.get(k).push(it);
  }
  const out = [];
  for (const k of REPORT_CLASSIFICATIONS) {
    const list = buckets.get(k) || [];
    if (list.length === 0) continue;
    out.push({ classification: k, label: REPORT_LABELS[k], items: list });
  }
  return out;
}
